import React, { Component } from 'react'
import { Checkbox, Icon } from 'loyal-react'
import PropTypes from 'prop-types'

import {
  AccordionItem,
  AccordionItemTitle,
  AccordionItemBody
} from 'react-accessible-accordion'

import 'react-accessible-accordion/dist/fancy-example.css'

class SelectedFilters extends Component {
    checkSelected = value => {
      let { category } = this.props.filterSelected
      switch (this.props.type) {
        case 'category': {
          return category ? category.includes(String(value)) : false
        }
        default: {

        }
      }
    }

    buildDescription = value => {
      return value.trim().length > 17 ? value.trim().substr(0, 27) + '...' : value.trim()
    }

    render () {
      const {
        type,
        filterSelected,
        expanded,
        title,
        items,
        handleFilterChanged
      } = this.props
      return (items && items.length) > 0 && (
        <AccordionItem
          expanded={expanded}
          className={`filter-accordion filtered-accordion border-color-ui-3 col-12 px-0 ${
            items ? '' : 'd-none'
          }`}
        >
          <AccordionItemTitle className='filter-accordion border-color-ui-3 col-12 px-0'>
            <button
              className='btn-accordion txt-left border-color-ui-3 txt-body-sm txt-uppercase-first'
              aria-label={title}
            >
              {title}
              <Icon iconName='icon_down' />
            </button>
          </AccordionItemTitle>
          <AccordionItemBody className='panel-accordion border-top border-color-ui-3 bg-white  px-2 py-2'>
            <div className='panel-scroll'>
              {items &&
            items.map((item, index) => (!filterSelected.category || this.checkSelected(item.id)) && (
              <Checkbox
                key={`${type}_${index}`}
                id={`${type}_${item.id}`}
                label={this.buildDescription(item.description)}
                labelClass='out'
                className='col-12 form-field-custom px-0'
                value={item.id}
                onChange={handleFilterChanged(type)}
                checked={this.checkSelected(item.id)}
                title={`${item.description}`}
              />
            ))}
            </div>
          </AccordionItemBody>
        </AccordionItem>
      )
    }
}

// schema
SelectedFilters.propTypes = {
  type: PropTypes.string.isRequired,
  filterSelected: PropTypes.any.isRequired,
  expanded: PropTypes.any.isRequired,
  title: PropTypes.string.isRequired,
  items: PropTypes.array,
  handleFilterChanged: PropTypes.func.isRequired
}

export default SelectedFilters



// WEBPACK FOOTER //
// ./src/features/MeuBairro/Filters/FilterItems.js